import 'css-chunksrc/client/scenes/listRemoval/listsList/commentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_1wj42_1",
  "count": "_count_1wj42_8",
  "icon": "_icon_1wj42_14"
};